var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndependant05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4517 11.25C29.4517 13.7353 23.9112 15.75 17.0767 15.75C10.2421 15.75 4.70166 13.7353 4.70166 11.25M29.4517 11.25C29.4517 8.76472 23.9112 6.75 17.0767 6.75C10.2421 6.75 4.70166 8.76472 4.70166 11.25M29.4517 11.25V21.2786C26.7033 22.104 24.9517 23.3526 24.9517 24.75M4.70166 11.25V38.25C4.70166 40.7353 10.2421 42.75 17.0767 42.75C20.0683 42.75 22.812 42.364 24.9517 41.7214V24.75M4.70166 20.25C4.70166 22.7353 10.2421 24.75 17.0767 24.75C20.0683 24.75 22.812 24.364 24.9517 23.7214M4.70166 29.25C4.70166 31.7353 10.2421 33.75 17.0767 33.75C20.0683 33.75 22.812 33.364 24.9517 32.7214M49.7017 24.75C49.7017 27.2353 44.1612 29.25 37.3267 29.25C30.4921 29.25 24.9517 27.2353 24.9517 24.75M49.7017 24.75C49.7017 22.2647 44.1612 20.25 37.3267 20.25C30.4921 20.25 24.9517 22.2647 24.9517 24.75M49.7017 24.75V42.75C49.7017 45.2353 44.1612 47.25 37.3267 47.25C30.4921 47.25 24.9517 45.2353 24.9517 42.75V24.75M49.7017 33.75C49.7017 36.2353 44.1612 38.25 37.3267 38.25C30.4921 38.25 24.9517 36.2353 24.9517 33.75",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependant05);
export default __webpack_public_path__ + "static/media/independant05.5358a9342f1dabe13ce2ca1ab5a369c8.svg";
export { ForwardRef as ReactComponent };